module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1l",
    attrs: {
      "id": "d7e142016"
    }
  }, [_vm._v("I Will ")]), _vm._v(" "), _c('table', {
    staticClass: "table",
    attrs: {
      "border": "0"
    }
  }, [_c('colgroup', [_c('col'), _c('col')]), _c('tbody', [_c('tr', [_c('td', [_vm._v("Listen for God’s direction in the encouraging words of a friend.")]), _c('td', [_vm._v("yes")]), _c('td', [_vm._v("no")])]), _c('tr', [_c('td', [_vm._v("Trust that God can use my friends to help me grow.")]), _c('td', [_vm._v("yes")]), _c('td', [_vm._v("no")])]), _c('tr', [_c('td', [_vm._v("Understand that a good friend is a gift from God.")]), _c('td', [_vm._v("yes")]), _c('td', [_vm._v("no")])]), _c('tr', [_c('td', [_vm._v("Listen to a friend’s words as intently as I would want my friend to listen to me.")]), _c('td', [_vm._v("yes")]), _c('td', [_vm._v("no")])]), _c('tr', [_c('td', [_vm._v("Know that a friend’s words are usually spoken out of concern.")]), _c('td', [_vm._v("yes")]), _c('td', [_vm._v("no")])]), _c('tr', [_c('td', [_vm._v("Learn to embrace a friend’s words.")]), _c('td', [_vm._v("yes")]), _c('td', [_vm._v("no")])]), _c('tr', [_c('td', [_vm._v("Attempt to encourage my friends as often as possible.\n")]), _c('td', [_vm._v("yes")]), _c('td', [_vm._v("no")])])])]), _c('p', {
    staticClass: "h1l",
    attrs: {
      "id": "d7e142716"
    }
  }, [_vm._v("Things to Do ")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e145416"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "bu",
      "src": "images/bu.jpg"
    }
  }), _c('i', [_vm._v(" Pray for wisdom to know how to encourage others.")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e145916"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "bu",
      "src": "images/bu.jpg"
    }
  }), _c('i', [_vm._v(" Write a thank-you note today to one friend who has encouraged you.")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e146516"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "bu",
      "src": "images/bu.jpg"
    }
  }), _c('i', [_vm._v(" Be prepared to offer a few words of encouragement to a friend.")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e147016"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "bu",
      "src": "images/bu.jpg"
    }
  }), _c('i', [_vm._v(" Invite a friend to consult with you on an upcoming decision.")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e147516"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "bu",
      "src": "images/bu.jpg"
    }
  }), _c('i', [_vm._v(" Call a friend to say how much you appreciate his or her friendship.")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e148116"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "bu",
      "src": "images/bu.jpg"
    }
  }), _c('i', [_vm._v(" Read about David and Jonathan’s friendship in 1 Samuel, chapters 19 ")]), _c('i', [_vm._v("and 20.")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e148916"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "bu",
      "src": "images/bu.jpg"
    }
  }), _c('i', [_vm._v(" Offer your friendship to someone with whom you’d like to have a closer ")]), _c('i', [_vm._v("relationship.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-987afdbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inc_9781418557720_epub_c12_r1.vue
// module id = 84
// module chunks = 0